import { ITEM_STATE_LOADING_FAILED } from "../../constants";

export default ({ itemState }) => itemState === ITEM_STATE_LOADING_FAILED;
